import { useRouter } from 'next/router';
import { Stack, Heading, Text } from '@chakra-ui/layout';

import { useGetUser } from '@/modules/user/userHooks';
import { useUserStore } from '@/modules/user/userStore';
import { ResponsiveButton } from '@/uikit/component/Button';
import { browserCookie } from '@/shared/cookie';

function AuthLoginCard() {
  const router = useRouter();
  const isLoggedIn = browserCookie.get('isLoggedIn') === 'true';
  const userStore = useUserStore();

  const userQuery = useGetUser({
    enabled: isLoggedIn,
    staleTime: 5 * 60 * 1000, // 5 minutes
    onSuccess: (data) => {
      if (data.length > 0) {
        userStore.setUser(data[0]);
      }
    },
  });

  const handleRedirect = (url: string) => {
    const redirectURL = encodeURIComponent(window.location.href);
    router.push(`${url}?redirect_url=${redirectURL}`);
  };

  return (
    <Stack
      background="primary.tealGreenGradient"
      direction="column"
      justifyContent="space-between"
      textAlign="center"
      boxShadow="0px 4px 12px -3px rgba(0, 0, 0, 0.2)"
      mx="auto"
      borderRadius="lg"
      spacing="2rem"
      width="18rem"
      px="2rem"
      py="3rem"
    >
      <Stack>
        <Heading color="white">File Uploader</Heading>
        <Text color="white">
          Upload file to Ruangguru&apos;s storage & use the link
        </Text>
      </Stack>
      <ResponsiveButton
        isLoading={userQuery.isLoading}
        isDisabled={userQuery.isLoading}
        onClick={() => handleRedirect('/login')}
        boxShadow="0px 4px 12px -8px rgba(0, 0, 0, 0.2)"
      >
        Login
      </ResponsiveButton>
    </Stack>
  );
}

export { AuthLoginCard };
